import React from 'react'

export function Icon ({icon}) {
    return <i className={"fa fa-" + icon} aria-hidden='true'/>
}

export function SocialIcon ({icon, url, className, label}) {
    return <a href={url} className={"share-btn " + className} aria-label={label}><i className={"fab fa-" + icon} aria-hidden='true' /></a>

}


export function Edit({icon}) {
    return <i className={"fa fa-" + icon} aria-hidden='true'/>
}

export function Delete ({icon}) {
    return <i className={"fa fa-" + icon} aria-hidden='true'/>
}